module.exports = __webpack_public_path__ + "static/img/1.95c3cd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/eng/1.png
// module id = HqQ6
// module chunks = 0